import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

import { timeZoneConverted } from "@/config";

type PatientTimezoneDateBlurbProps = {
  accountTimeZone?: string | null;
  alternateText?: string;
  sx?: SxProps<Theme>;
};

export const PatientTimezoneDateBlurb: React.FC<PatientTimezoneDateBlurbProps> = ({
  accountTimeZone,
  alternateText,
  sx,
}) => (
  <Box sx={{ fontSize: "0.8rem", color: "#666", mb: 2, ...(sx ?? {}) }}>
    {(alternateText || "Dates shown are in the patient's timezone: ") +
      timeZoneConverted(accountTimeZone ?? undefined)}
  </Box>
);
